import React from 'react';
export function IncludesSection() {
  return <section className="w-full bg-white py-8 px-4 border-t border-gray-200" data-id="element-125">
      <div className="max-w-2xl mx-auto text-center" data-id="element-126">
        <h2 className="text-3xl md:text-4xl font-black text-black mb-4" data-id="element-127">
          ¿Qué incluye exactamente?
        </h2>

        <h3 className="text-2xl md:text-3xl font-black mb-2" data-id="element-128">
          Ebook principal:{' '}
          <span className="text-red-600" data-id="element-129">Aprendizaje en Casa</span>
        </h3>

        <a href="#compra" className="block max-w-xs mx-auto my-5" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/wKWLMw3KQnGVPp1oRAKSPb/imagen_principal_pagina.png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto" data-id="element-131" />
        </a>

        <p className="text-xl font-bold text-gray-800 mb-8" data-id="element-132">
          Una guía psicopedagógica donde vas a descubrir:
        </p>

        <ul className="text-left max-w-md mx-auto space-y-3 text-lg md:text-xl font-bold text-gray-800 mb-10" data-id="element-133">
          <li className="flex items-start" data-id="element-134">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-135">✓</span>
            por qué los niños se distraen fácilmente
          </li>
          <li className="flex items-start" data-id="element-136">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-137">✓</span>
            cómo funciona su aprendizaje
          </li>
          <li className="flex items-start" data-id="element-138">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-139">✓</span>
            qué afecta su concentración
          </li>
          <li className="flex items-start" data-id="element-140">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-141">✓</span>
            cómo acompañar sin conflictos
          </li>
          <li className="flex items-start" data-id="element-142">
            <span className="text-green-600 mr-3 flex-shrink-0" data-id="element-143">✓</span>
            estrategias para motivarlos
          </li>
        </ul>

        <p className="text-lg font-bold text-gray-600 bg-yellow-100 inline-block px-4 py-2" data-id="element-144">
          Todo explicado de forma simple y aplicable.
        </p>
      </div>
    </section>;
}